import factory from './icon';
import UncheckedSvg14x14 from './glyphs/Checkbox_14x14.svg';
import CheckedSvg14x14 from './glyphs/CheckboxChecked_14x14.svg';

export const Unchecked14x14 = factory(UncheckedSvg14x14, 14, 14);
export const Checked14x14 = factory(CheckedSvg14x14, 14, 14);
